let config

const DEFAULT_CONFIG = {
    backEndUrl: '',
    frontEndUrl: '',
    cookieMaxAge:  150000,
}

config = DEFAULT_CONFIG

config = {
    backEndUrl: window.__CONFIG__?.API_URL ? `${window.__CONFIG__?.API_URL}/`: DEFAULT_CONFIG.backEndUrl,
    frontEndUrl: window.__CONFIG__?.APP_URL ? `${window.__CONFIG__?.APP_URL}/` : DEFAULT_CONFIG.frontEndUrl,
    cookieMaxAge: window.__CONFIG__?.COOKIE_MAX_AGE ? window.__CONFIG__?.COOKIE_MAX_AGE : DEFAULT_CONFIG.cookieMaxAge
}

export default config;
